export default __webpack_public_path__ + "static/media/IkonParaplySort.9a1594b0.svg";